import React from 'react';
import styled from 'styled-components';
import { MenuItem, Select } from '@material-ui/core';
import { CHANNELS, EMAIL_ONLY_TILES } from '../utils/rates';
import { METRIC_COLORS } from '../utils/graph';
import { TILE_ICONS } from '../components/MessageTable/StatTile';
import { BORDER, GREY_TEXT } from '../AnalyticsV2.styled';
import { Section } from './MessageDetail.styled';
import StatCard from './StatCard';
import StatCardAB from './StatCardAB';
import GraphToggle from './GraphToggle';

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${BORDER};
`;

const Heading = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: #1c1c1c;
`;

const FilterLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${GREY_TEXT};
`;

const ChannelSelect = styled(Select)`
  &.MuiInputBase-root {
    min-width: 140px;
    font-size: 13px;
    background: #ffffff;
  }
  .MuiSelect-root {
    padding: 8px 32px 8px 12px;
  }
`;

const Help = styled.span`
  font-size: 13px;
  color: ${GREY_TEXT};
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 24px;
`;

// A shown metric's tile gets a border in the metric's line colour.
const Frame = styled.div`
  border: 3px solid ${({ $color }) => $color || 'transparent'};
  border-radius: 10px;
`;

// The "Stats" section: channel filter and the tiles. Clicking a tile opens
// its drawer; its graph icon adds or removes its metric on the graph.
// tiles: from getTileValues (detail page) or getCombinedTileValues (combined
// page). isSmallValue: show the values small, as for a scheduled or cancelled
// message. metrics: the metrics on the graph, by tile key.
const StatTiles = ({
  tiles,
  isSmallValue,
  channel,
  onChannelChange,
  metrics,
  onToggleMetric,
  onTileClick,
}) => {
  return (
    <Section>
      <Header>
        <Heading>Stats</Heading>
        <FilterLabel>
          Filter by:
          <ChannelSelect
            variant="outlined"
            value={channel}
            onChange={event => onChannelChange(event.target.value)}
          >
            {CHANNELS.map(({ key, label }) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </ChannelSelect>
        </FilterLabel>
        <Help>
          Select stats to show on graphs. Click a stat for more details.
        </Help>
      </Header>
      <Grid>
        {tiles.map(tile => {
          const isSelected = metrics.includes(tile.key);
          const Card = tile.isAB ? StatCardAB : StatCard;
          return (
            <Frame
              key={tile.key}
              $color={isSelected && METRIC_COLORS[tile.key]}
            >
              <Card
                tile={tile}
                Icon={TILE_ICONS[tile.key]}
                isSmallValue={isSmallValue}
                isEmailOnly={
                  channel === 'all' && EMAIL_ONLY_TILES.includes(tile.key)
                }
                onClick={tile.noDataText ? null : () => onTileClick(tile.key)}
                graphToggle={
                  <GraphToggle
                    label={tile.name}
                    color={METRIC_COLORS[tile.key]}
                    isSelected={isSelected}
                    isLocked={isSelected && metrics.length === 1}
                    onToggle={() => onToggleMetric(tile.key)}
                  />
                }
              />
            </Frame>
          );
        })}
      </Grid>
    </Section>
  );
};

export default StatTiles;
